<template>
  <div class="rounded-6 mb-3 border bold-shadow p-3">
		<div class="row no-gutters">
			<div class="col-8 align-self-center">
				<div class="pr-3">
					<p class="mb-0 body-2-1">{{data}}</p>
				</div>
			</div>
			<div class="col-4 align-self-center">
				<button
					v-if="qty_cart == 0"
					@click="changeQty('plus')" 
					class="ga-btn-primary-outline w-100">
					Select
				</button>
				<div class="plus-min-set w-100 text-right" v-else>
          <img src="../../../../assets/img/icon/decrement.png" class="d-inline-block img-crement rounded-100" width="28"
            style="border:1px solid #70707046;" @click="changeQty('minus')">
          <p class="d-inline-block border-none text-center body-2-4 counter mb-0" style="width:35px;">{{qty_cart}}</p>
          <img src="../../../../assets/img/icon/increment.png" class="d-inline-block border-green img-crement rounded-100"
            width="28" @click="changeQty('plus')">
        </div>
			</div>
		</div>
	</div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default{
		props: ['data','product_cart_index'],
		data(){
			return{
				qty_cart: 0
			}
		},
		computed:{
			...mapGetters(['getConciergeOrder']),
			variant_in_cart(){
				let return_data = -1
				if(this.product_cart_index != -1){
					return_data = this.getConciergeOrder.cart[this.product_cart_index].variant.findIndex(x=>x.data == this.data)
				}
				return return_data
			},
		},
		watch:{
			qty_cart(){
				this.$emit('updateQty',{
					data: this.data,
					qty: this.qty_cart 
				})
			}
		},
		mounted(){
			if(this.variant_in_cart != -1) {
				this.qty_cart = this.getConciergeOrder.cart[this.product_cart_index].variant[this.variant_in_cart].qty
			}
		},
		methods:{
			changeQty(type){
				if(type == 'plus'){
					this.qty_cart++
				}else{
					if(this.qty_cart > 0){
						this.qty_cart--
					}
				}
			}
		}
	}
</script>
<style scoped>
	.img-crement {
    padding: 7px;
    border-radius: 5px;
  }
	@media screen and (max-width: 600px) {
    .plus-min-set {
      margin-left: -20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/MenuVariantNotesFoodSquare.vue